import { styled } from '@mui/system';
import { Paper, InputBase, Box, IconButton } from '@mui/material';

const BORDER_COLOR = 'rgb(214 214 214 / 72%)';

export const FilterDropdownPaper = styled(Paper)({
  maxHeight: '350px !important',
  maxWidth: '404px !important',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '16px !important',
  boxShadow: `
    -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15),
    4px 4px 15px 0px rgba(205, 214, 223, 0.25)
  !important`,
});

export const FilterSearchHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  borderBottom: `1px solid ${BORDER_COLOR}`,
  flexShrink: 0,
});

export const FilterSearchInput = styled(InputBase)(({ theme }) => ({
  flex: 1,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  transform: 'translateZ(0)',
  WebkitTransform: 'translateZ(0)',
  '& input': {
    caretColor: 'currentColor',
  },
}));

export const FilterScrollContainer = styled(Box)({
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
});

export const FilterSelectIconButton = styled(IconButton)({
  position: 'absolute',
  right: 4,
});
